import type { ReadonlyRefOrGetter } from "@vueuse/core";
import { ProductSorting } from "mws-ts-v2-sdk";

export type FilterResponse = {
  minimumPrice?: { [key: string]: number } | null;
  maximumPrice?: { [key: string]: number } | null;
  categoryFilters: Record<
    string,
    Array<{
      label: string;
      value: string;
    }>
  >;
};

const getAppliedFilterTypes = (
  routeQuery: Record<string, any>,
  availableFilters?: FilterResponse,
) => {
  let appliedFilterTypes: string[] = [];

  const priceFromFilterType = routeQuery.priceFrom && "priceFrom";
  const priceToFilterType = routeQuery.priceTo && "priceTo";
  const statusFilterType = routeQuery.productStatus && "status";

  const filterCategories = availableFilters?.categoryFilters;
  const routeCategories =
    transformRouteParams(routeQuery.category, "array") ?? [];

  if (filterCategories) {
    appliedFilterTypes = [
      ...getAppliedCategoryFilterTypes(filterCategories, routeCategories),
    ];
  }

  if (priceFromFilterType) {
    appliedFilterTypes.push(priceFromFilterType);
  }

  if (priceToFilterType) {
    appliedFilterTypes.push(priceToFilterType);
  }

  if (statusFilterType) {
    appliedFilterTypes.push(statusFilterType);
  }

  return appliedFilterTypes;
};

export default createSharedComposable(function useTrackAppliedProductFilters(
  pageType: ReadonlyRefOrGetter<"event" | "search" | "category">,
  availableFilters: ReadonlyRefOrGetter<FilterResponse | undefined>,
) {
  const { filtersApplied } = useAnalytics();

  const trackAppliedProductFilters = (routeQuery: Record<string, any>) => {
    const MAP = {
      event: "eventDetailsPage",
      search: "searchProductsPage",
      category: "categoryPage",
    } as const;

    filtersApplied({
      sort:
        transformRouteParams(routeQuery.sort, "string") ??
        ProductSorting.Featured,
      filters: getAppliedFilterTypes(routeQuery, toValue(availableFilters)),
      page_type: MAP[toValue(pageType)],
    });
  };

  const route = useRoute();
  debouncedWatch(() => route.query, trackAppliedProductFilters, {
    debounce: 500,
  });
});
